// theme.ts
export enum ThemeEnum {
    LIGHT = "light",
    DARK = "dark",
}

export const LS_KEY = "theme";
export const DARK_CLASS = "dark";
